import { render, staticRenderFns } from "./Gestion.vue?vue&type=template&id=ba06ddd4&"
import script from "./Gestion.vue?vue&type=script&lang=js&"
export * from "./Gestion.vue?vue&type=script&lang=js&"
import style0 from "./Gestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports